import { connect } from 'react-redux';
import { getScopes, deleteScope } from 'core/slices/scopes';
import { updateTask, deleteTask } from 'core/slices/tasks';
import { loadingUpdate } from 'core/slices/loading';
import { getProjects } from 'core/slices/projects';
import { fetchTaskSuggestions, saveSuggestedTasks } from 'core/slices/tasksSuggestions'
import { getRole, getSuggestedTasks, isLoadingTaskSuggestions, isScopesSuggestionsLoading, getSuggestedForScopeId } from 'core/selectors';
import Scope from '../../../components/project/Scope';

export default connect(
  state => ({
    getRole: getRole(state),
    suggestedTasks: getSuggestedTasks(state),
    isLoadingTaskSuggestions: isLoadingTaskSuggestions(state),
    isScopesSuggestionsLoading: isScopesSuggestionsLoading(state),
    suggestedForScopeId: getSuggestedForScopeId(state),
  }),
  {
    updateTask,
    getScopes,
    deleteScope,
    loadingUpdate,
    deleteTask,
    getProjects,
    fetchTaskSuggestions,
    saveSuggestedTasks,
  },
)(Scope);
